import BottleFlip from "./game";
import React from "react";
import ReactDOM from "react-dom";
import { rem } from "./utils";
import glamorous, { Div } from "glamorous";

const game = new BottleFlip();

var timepass = window.timepass;
var reviveGrowthFactor = 1;

function syncScoreInTournament() {
  setTimeout(function () {
    timepass.logGameEvents(
      "[TOURNAMENT MODE] Sync Score Called, With Score: " + game.score
    );
    timepass.syncScore(game.score);
  }, timepass.getTournamentTime() * 1000);

  setTimeout(function () {
    timepass.logGameEvents("[TOURNAMENT MODE] Game Over Called");
    timepass.gameOver();
  }, timepass.getTournamentTime() * 1000);
}

function syncScoreInChallenge() {
  setTimeout(function () {
    timepass.logGameEvents(
      "[CHALLENGE MODE] Sync Score Called, With Score: " + game.score
    );
    timepass.syncScore(game.score);
   
  }, timepass.getChallengeTime() * 1000);

  setTimeout(function () {
    timepass.logGameEvents("[CHALLENGE MODE] Game Over Called");
    timepass.gameOver();
  }, timepass.getChallengeTime() * 1000);
}

// Start the game
game.start();
timepass.logGameEvents("Game Started Called");
timepass.gameStarted();

const Button = glamorous.div({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  backgroundColor: "#fdfdfd",
  color: "#000",
  fontWeight: "bold",
  fontSize: rem(54),
  lineHeight: "normal",
  height: rem(156),
  width: rem(512),
  borderRadius: rem(50 / 2),
  margin: "0 auto",
  boxShadow: `10 ${rem(4)} ${rem(12)} ${rem(4)} rgba(113, 113, 113, 0.4)`,
});

const Wrapper = glamorous.div({
  width: "10rem",
  margin: "0 auto",
  position: "relative",
  minHeight: "100%",
});

class Landing extends React.Component {
  componentDidMount() {
    this.props.onStart();
  }
  handleStartClick = (e) => {
    this.props.onStart();
  };

  render() {
    return (
      <div
        style={{
          position: "fixed",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          background: "rgba(0, 0, 0, 0.3)",
          color: "#ffffff",
        }}
      >
        <Wrapper>
          <Div
            fontSize={rem(148)}
            fontWeight="bold"
            textAlign="center"
            paddingTop={rem(340)}
          >
            Bottle Flip
          </Div>
          <Div position="absolute" bottom={rem(259)} width="100%">
            <Div marginTop={rem(128)}>
              <Button onClick={this.handleStartClick}>Start Game</Button>
            </Div>
          </Div>
        </Wrapper>
      </div>
    );
  }
}

function syncScore(score) {
  timepass.logGameEvents("Sync Score Called, With Score: " + score);
  timepass.updateCurrentStats(null,null,game.score);
  timepass.syncScore(score);
}

async function setState(highest) {
  await timepass.syncState({ highest });
}
function showPurchaseOption() {
  
  //console.log(timepass.getshowPurchaseOptionFlag() + "show purchase flag");
  // eslint-disable-next-line
  if(timepass.getshowPurchaseOptionFlag() == "true" || timepass.getshowPurchaseOptionFlag() == "" || timepass.getshowPurchaseOptionFlag() == null)
    {
  timepass.showPurchaseOptions(
    "8155b9a2-376b-414e-9bdc-cab842142d53",
    reviveGrowthFactor);
    }

else{
     purchaseCompleted("8155b9a2-376b-414e-9bdc-cab842142d53", "");
    }
 
}

export function purchaseCompleted(productid, purchaseType) {
  if (productid === "8155b9a2-376b-414e-9bdc-cab842142d53") {
    game.revive();
    console.log(game.score);

    if (purchaseType === "coin") {
      reviveGrowthFactor += 1;
    }

    // Expose a way to update the state of the app to STATE_GAME
    if (typeof window.setAppState === "function") {
      window.setAppState(STATE_GAME);
    }
  }
}

class Game extends React.Component {
  container = null;
  state = {
    started: false,
  };
  onRef = (ref) => {
    this.container = ref;
  };

  handleGameOver = async () => {
    this.props.onGameOver();
  };

  componentDidMount() {
    this.container.appendChild(game.renderer.domElement);
    game.addEventListener("gameover", this.handleGameOver);
  }

  componentWillUnmount() {
    this.container.removeChild(game.renderer.domElement);
    game.removeEventListener("gameover", this.handleGameOver);
  }

  render() {
    return (
      <Wrapper>
        <div ref={this.onRef}></div>
      </Wrapper>
    );
  }
}

class Score extends React.Component {
  handleReviveClick = () => {
    // showPurchaseOption();
    this.props.onRevive(); // Call the onRevive prop to handle state change
  };

  render() {
    const showReviveButton =
      timepass.getChallengeMode() !== "true" &&
      timepass.getTournamentMode() !== "true" && 
      (timepass.getshowPurchaseOptionFlag()!=="false"||timepass.getshowPurchaseOptionFlag()=== null || timepass.getshowPurchaseOptionFlag()=== "");

    return (
      <div
        style={{
          position: "fixed",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          background: "rgba(0, 0, 0, 0.8)",
          color: "#ffffff",
        }}
      >
        <Wrapper>
          <Div textAlign="center" fontSize={rem(34)} paddingTop={rem(200)}>
            Round Score{" "}
            <span role="img" aria-label="Trophy">
              🏆
            </span>
          </Div>
          <Div
            textAlign="center"
            fontSize={rem(146)}
            fontWeight="bold"
            marginTop={rem(20)}
            marginBottom={rem(40)}
          >
            {this.props.round}
          </Div>
          <Div
            position="absolute"
            bottom={rem(140)} // Adjusted bottom position to ensure proper spacing
            width="100%"
          >
            {showReviveButton && (
              <Div marginBottom={rem(20)}>
                <Button onClick={this.handleReviveClick}>
                  Revive{" "}
                  <span role="img" aria-label="Heart">
                    ❤️
                  </span>
                </Button>
              </Div>
            )}
            <Div marginBottom={rem(20)}>
              {" "}
              {/* Added margin to separate the buttons */}
              <Button onClick={this.props.onRestart}>
                Try Again{" "}
                <span role="img" aria-label="Refresh">
                  🔁
                </span>
              </Button>
            </Div>
            <Div
              fontSize={rem(36)}
              textAlign="center"
              position="absolute"
              width="100%"
              bottom={rem(-40)}
            >
              {" "}
              {/* Adjusted bottom position to ensure it's not hidden */}
              Highest Score: {this.props.highest}
            </Div>
          </Div>
        </Wrapper>
      </div>
    );
  }
}

const STATE_LANDING = "landing";
const STATE_GAME = "game";
const STATE_GAMEOVER = "gameover";

class App extends React.Component {
  state = {
    state: STATE_LANDING,
    highest: parseInt(localStorage.getItem("highest") || "0", 10),
    round: 0,
    adFrequency: 14,
    playedChances: 1,
  };

  componentDidMount() {
    const uid = timepass.getUserId();
    timepass.analytics.configureGameAnalyticsUserId(uid);
    timepass.analytics.initializeGameAnalytics(
      "20446c7524c75f103f802504356e73c6",
      "ca65180594f734889f5c3fdb14f85b328e71aeb7"
    );
    timepass.pageReady();

    const isBusinessPlatform = timepass.getIsBusinessPlatform();
    console.log(isBusinessPlatform);

    if(isBusinessPlatform === "true"){
        timepass.analytics
              .getGameAnalyticsRemoteConfigs("b2b_ad_frequency", "2")
              .then((value) => {
               this.adFrequency = value,
                   console.log("ad Frequency"+ this.adFrequency);
              })
              .catch((error) => {
                console.error("Error:", error);
              });
    }
    if(isBusinessPlatform !== "true")
    {
      timepass.analytics
            .getGameAnalyticsRemoteConfigs("ad_frequency", "5")
            .then((value) => {
              this.adFrequency = value,
              console.log("ad Frequency"+this.adFrequency);
            })
            .catch((error) => {
              console.error("Error:", error);
            });
    }
    

    if (
      timepass.getTournamentMode() === "true" &&
      timepass.getTournamentType() === "time"
    ) {
      syncScoreInTournament();
    }

    if (
      timepass.getChallengeMode() === "true" &&
      timepass.getChallengeType() === "time"
    ) {
      syncScoreInChallenge();
    }

    // Expose a global function to set the app state
    window.setAppState = (newState) => {
      this.setState({ state: newState });
    };
  }

  renderUI() {
    async function getState() {
      try {
        const state = await timepass.getState();
        if (!!state.highest) {
          localStorage.setItem("highest", state.highest);
        }
        return state;
      } catch (error) {
        console.error({ error });
      }
    }
    const handleGameStart = async () => {
      if (timepass.getStateSyncEnabled() === "true") {
        const state = await getState();
        if (!!state.highest) {
          this.setState({ highest: state.highest });
        }
      }
      game.restart();
      this.setState({ state: STATE_GAME });
    };

    const handleGameRestart = () => {
      game.restart();
      this.setState({
        state: STATE_GAME,
      });
    };

    const handleRevive = () => {
      showPurchaseOption();
      this.setState((prevState) => ({
        round: game.score,
        playedChances: prevState.playedChances + 1,
      }));
    };

    switch (this.state.state) {
      case STATE_GAMEOVER:
        return (
          <Score
            round={this.state.round}
            highest={this.state.highest}
            onRestart={handleGameRestart}
            onRevive={handleRevive}
          />
        );
      case STATE_LANDING:
        return <Landing onStart={handleGameStart} />;
      case STATE_GAME:
      default:
        return null;
    }
  }

  render() {
    const handleChancesInChallenge = () => {
			if (
				timepass.getChallengeMode() === 'true' &&
				timepass.getChallengeType() === 'chance'
			) {
				if (
          // eslint-disable-next-line
					this.state.playedChances == timepass.getChallengeChances()
				) {
					timepass.logGameEvents('[Challenge MODE] Game Over Called')
					timepass.gameOver()
				} else {
					timepass.logGameEvents(
						'[Challenge MODE] Chance Left Called, With Chance: ' +
							timepass.getChallengeChances() -
							this.state.playedChances
					)
					timepass.gameChanceLeft(
						timepass.getChallengeChances() - this.state.playedChances
					)
				}
			}
		}

		const handleChancesInTournament = () => {
			if (
        // eslint-disable-next-line
				timepass.getTournamentMode() == 'true' &&
				timepass.getTournamentType() === 'chance'
			) {
				if (
          // eslint-disable-next-line
					this.state.playedChances == timepass.getTournamentChances()
				) {
					timepass.logGameEvents('[TOURNAMENT MODE] Game Over Called')
					timepass.gameOver()
				} else {
					timepass.logGameEvents(
						'[TOURNAMENT MODE] Chance Left Called, With Chance: ' +
							timepass.getTournamentChances() -
							this.state.playedChances
					)
					timepass.gameChanceLeft(
						timepass.getTournamentChances() - this.state.playedChances
					)
				}
			}
		}
    const handleGameOver = () => {
      handleChancesInChallenge();
      handleChancesInTournament();
      // Tournament
      if (this.state.playedChances % Number(this.adFrequency) === 0) {
        timepass.showAds();
      }
      syncScore(game.score);
      let highest = this.state.highest;
      if (game.score > highest) {
        highest = game.score;
        localStorage.setItem("highest", highest.toString());
        setState(game.score);
      }
      this.setState({
        highest,
        round: game.score,
        state: STATE_GAMEOVER,
        playedChances: this.state.playedChances + 1,
      });
      timepass.analytics.sendGameAnalyticsProgressionEvent({
        progressEvent: "Complete",
        progressOne: "Score",
        score: game.score,
      });
    };
    return (
      <React.Fragment>
        <Game onGameOver={handleGameOver} />
        {this.renderUI()}
      </React.Fragment>
    );
  }
}

ReactDOM.render(<App />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js